"use strict";
const STYLE_ELEMENT_ID = "decidim-insights-modal-styles";
const MODAL_CSS = `
.analytics-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.analytics-modal {
  background: #fff;
  border-radius: 8px;
  width: 90vw;
  max-width: 900px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
}

.analytics-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.analytics-modal__title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.analytics-modal__close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 4px 8px;
  color: #6b7280;
}

.analytics-modal__close:hover {
  color: #111;
}

.analytics-modal__tabs {
  display: flex;
  gap: 4px;
  padding: 8px 24px 0;
  border-bottom: 1px solid #e5e7eb;
}

.analytics-tab {
  padding: 8px 16px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 0.875rem;
  color: #6b7280;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
}

.analytics-tab:hover {
  color: #111;
}

.analytics-tab--active {
  color: #2563eb;
  border-bottom-color: #2563eb;
  font-weight: 500;
}

.analytics-modal__content {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.analytics-modal__message {
  color: #6b7280;
}

.analytics-modal__error {
  color: #dc2626;
}

.analytics-tab-panel {
  display: none;
}

.analytics-tab-panel--active {
  display: block;
}

.analytics-visualisation__image {
  display: block;
  max-width: 100%;
  height: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.analytics-visualisation__description {
  margin-top: 12px;
  font-size: 0.875rem;
  color: #6b7280;
}

.analytics-visualisation__unavailable {
  padding: 24px;
  text-align: center;
  color: #6b7280;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
}

.analytics-method-notes {
  margin-top: 16px;
  font-size: 13px;
  color: #6b7280;
}

.analytics-method-notes summary {
  cursor: pointer;
}

.analytics-method-notes ul {
  margin: 8px 0 0;
  padding-left: 20px;
}

.summarise-modal__summary {
  margin-bottom: 16px;
  line-height: 1.6;
}

.summarise-modal__section + .summarise-modal__section {
  margin-top: 24px;
}

.summarise-modal__section-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: #111;
  margin: 0 0 8px;
}

.summarise-modal__points {
  margin: 0;
  padding-left: 20px;
}

.summarise-modal__points--numbered {
  list-style-type: decimal;
}

.summarise-modal__meta {
  margin-top: 16px;
  font-size: 0.875rem;
  color: #6b7280;
}

.summarise-modal__debug {
  margin-top: 16px;
  font-size: 13px;
}

.summarise-modal__debug summary {
  cursor: pointer;
}

.summarise-modal__debug pre {
  max-height: 300px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}
`;
export function ensureModalStyles() {
  if (document.getElementById(STYLE_ELEMENT_ID)) return;
  const style = document.createElement("style");
  style.id = STYLE_ELEMENT_ID;
  style.textContent = MODAL_CSS;
  document.head.appendChild(style);
}
